import * as React from "react";

import { showModal } from "../Component/popups"
import { BaseDialogFormComponent } from "../Component/BaseDialogFormComponent"
import { appContext } from "../App/appContext"

import Models = Gf.Web.Models;

export function showSetPasswordPopup(request: Models.SetPasswordRequest) {
    appContext.get(`/Login/NameRequired?username=${request.Username}`, (setName: boolean) => {
        request.SetName = setName;
        showModal(<SetPassword {...request} />);
    });
}

function setPassword(request: Models.SetPasswordRequest, clickedEmailLink: boolean, consumer: (errorMessage: string) => void): void {
    appContext.post("/Login/SetPassword",
        request,
        (response: Models.SetPasswordResponse) => reloadIfNoError(consumer, clickedEmailLink, response.ErrorMessage));
}

function reloadIfNoError(consumer: (errorMessage: string) => void, clickedEmailLink: boolean, errorMessage: string | null) {
    if (!errorMessage) {
        if (clickedEmailLink) {
            window.location.replace("/");
        } else {
            window.location.reload();
        }
    } else {
        consumer(errorMessage);
    }
}

class SetPassword extends BaseDialogFormComponent<Models.SetPasswordRequest> {
    constructor(props: Models.SetPasswordRequest) { super(props); }
    title() {
        return <div>
            <div>Sett et nytt passord</div>
            {this.alreadyLoggedIn() ? null : <small>{this.props.ClickedEmailLink
                ? "Du har klikket på lenken i e-posten vi sendte deg"
                : "Hvis e-postadressen din finnes i systemet så vil du snart motta engangskoden"}</small>}
        </div>;
    }
    alreadyLoggedIn() { return this.props.Username === appContext.innloggetBruker; }
    body() {
        return <div>
                   {this.field("E-postadresse", "Username", "username") }
                   {this.field("Passord", "Password", "password") }
                   {this.field("Gjenta passord", "RepeatPassword", "password") }
                   {this.props.ClickedEmailLink || this.alreadyLoggedIn() ? null : this.field("Engangskode", "Code", "text") }
                   {this.props.SetName ? this.field("Ditt fulle navn", "Name", "text") : null}
               </div>;
    }
    buttons() {
        return [
            this.button("Avbryt", "button", consumer => {
                if (this.props.ClickedEmailLink) {
                    reloadIfNoError(consumer, true, null);
                } else {
                    consumer(null);
                }
            }),
            this.button("Sett passord", "submit", consumer => setPassword(this.state.model, this.props.ClickedEmailLink, consumer), "primary")
        ];
    }
    isDisabled(field: keyof Models.SetPasswordRequest) { return field === "Username" || (this.props.ClickedEmailLink && field === "Code") || super.isDisabled(field); }
    requiredFields() { return ["Username", this.alreadyLoggedIn() ? null : "Code", "Password", "RepeatPassword", this.props.SetName ? "Name" : null]; }
    extraValidation() {
        const passwordMinLength = 8;
        return this.getModelField("Password") !== this.getModelField("RepeatPassword")
            ? "Passordet ble ikke gjentatt riktig"
            : this.getModelField("Password").length < passwordMinLength
                ? `Passordet må være på minst ${passwordMinLength} tegn`
                : null;
    }
}



// WEBPACK FOOTER //
// ./Scripts/React/Login/SetPassword.tsx